import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
// @mui
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  CircularProgress,
  Box,
  TextField,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
// components
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import Iconify from "../components/iconify";

import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import QuestionsTable from "src/components/pickem-admin/QuestionsTable";

// ----------------------------------------------------------------------

const dateFormat = "YYYY-MM-DD HH-mm-ss";
export default function UserSelectionsPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isScoringMode, setIsScoringMode] = useState(false);
  const [pickemStart, setPickemStart] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const [state, setState] = useState({
    title_en: "",
    title_fr: "",
  });

  useEffect(() => {
    if (searchParams.has("pickem_id")) {
      let pickemId = searchParams.get("pickem_id");
      let userId = searchParams.get("user_id");
      axios
        .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}`)
        .then(function (response) {
          let pickem = response.data.pickem
          axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/admin/pickems/${pickemId}/user-selections/${userId}`)
            .then(function (response) {
              mergeUserSelections(pickem, response.data.selections)

              setLoading(false);
            });
        });
    }
  }, []);

  const mergeUserSelections = (pickem, userSelections) => {
    const tiebreaker =  userSelections.find(item=>item.option_id===0)
    pickem.questions = pickem.questions.map(question => {
      if(question.question_id===tiebreaker?.question_id){
        question.custom_value=tiebreaker.custom_value
        return question
      }
      question.options = question.options.map(option => {
        let userQuestionSelections = userSelections.find(selection => selection.question_id === question.question_id);
        if(userQuestionSelections.custom_value){
          option.custom_value = userQuestionSelections.custom_value
        }
        if (!userQuestionSelections) {
          return option;
        }

        option.isSelected = userQuestionSelections.option_id === option.option_id;

        return option;
      })

      return question;
    });
    setState(pickem);
  }


  const deleteQuestionHandler = (index) => {
    axios
      .delete(
        `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${state.pickem_id}?question_id=${state.questions[index].question_id}`
      )
      .then((response) => {
        window.location.reload(false);
      });
  };

  const optionClickHandler = (questionId, optionId) => {
    if (isScoringMode) {
      let questionIndex = state.questions.findIndex(
        (question) => question.question_id === questionId
      );
      if (questionIndex !== -1) {
        let optionIndex = state.questions[questionIndex].options.findIndex(
          (option) => option.option_id === optionId
        );

        if (optionIndex !== -1) {
          let isCorrect =
            state.questions[questionIndex].options[optionIndex]?.isCorrect &&
            state.questions[questionIndex].options[optionIndex].isCorrect === 1
              ? 0
              : 1;
          state.questions[questionIndex].options[optionIndex].isCorrect =
            isCorrect;
          setState({ ...state });
        }
      }
    }
  };

  const saveScoringQuestions = () => {
    let questionUpdatePromises = [];

    for (let i = 0; i < state.questions.length; i++) {
      let question = state.questions[i];
      questionUpdatePromises.push(
        axios.put(
          `${process.env.REACT_APP_API_BASE_URL}/admin/pickem-questions/${state.pickem_id}?question_id=${question.question_id}`,
          question
        )
      );
    }

    Promise.all(questionUpdatePromises)
      .then((response) => {
        window.location.reload(false);
      })
      .catch((error) => console.log("Update questions ERROR", error));
  };

  console.log('state', state)
  return (
    <>
      <Helmet>
        <title> User Selections </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
          User Selections
          </Typography>

          <Box>
            <Button
              variant="outlined"
              startIcon={<Iconify icon="eva:chevron-left-outline" />}
              onClick={() => navigate(`/dashboard/pickems`)}
              sx={{ mr: 2 }}
            >
              BACK
            </Button>
          </Box>
        </Stack>

        <Card sx={{ padding: 4, marginBottom: 4 }}>
          <Typography variant="h5" sx={{ marginBottom: 2 }}>
            User Selections
          </Typography>
          {loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <>
                  <QuestionsTable
                    lang={"en"}
                    questions={state.questions}
                    pickemId={state.pickem_id}
                    deleteQuestionHandler={() => {}}
                    optionClickHandler={() => {}}
                    showActions={false}
                  />
            </>
          )}
        </Card>
      </Container>
    </>
  );
}
